import { IPublicRegionDto } from '../../../repositories/geo/entities/NearlyLocations/PublicRegionDto';
import { NonEmptyArray } from '../../../types/nonEmptyArray';
import { IRegion } from '../types';

export function prepareRegions(regions: IPublicRegionDto[] | null | undefined): NonEmptyArray<IRegion> | null {
  const preparedRegions = (regions || []).filter((region: IPublicRegionDto): region is IRegion => !!region.displayName);

  return preparedRegions.length > 0 ? (preparedRegions as NonEmptyArray<IRegion>) : null;
}
